import React from "react";
import { Link } from "react-router-dom";
import "../styles/StudentDashboard.css";

function StudentDashboard({ user }) {
  return (
    <div className="dashboard-bg">
      <div className="dashboard-card">
        <h2>
          Welcome, <span className="dashboard-username">{user?.username}!</span>
        </h2>
        <div className="dashboard-links">
          <Link to="profile" className="dashboard-link">
            <i className="fas fa-user" aria-hidden="true"></i> View Profile
          </Link>
          <Link to="pay" className="dashboard-link">
            <i className="fas fa-credit-card" aria-hidden="true"></i> Pay Fees
          </Link>
          <Link to="history" className="dashboard-link">
            <i className="fas fa-history" aria-hidden="true"></i> Fee Payment History
          </Link>
        </div>
      </div>
    </div>
  );
}

export default StudentDashboard;